<div class="container">
	<h4>Committees</h4>
	<hr />

	<div class="form-inline mb-3">
		<label class="mr-2 text-muted small mb-0">Period of review ending in</label>
		<select class="form-control form-control-sm"
			[ngModel]="selectedYear"
			(ngModelChange)="selectYear($event)"
			[disabled]="years.length === 0">
			<option *ngFor="let y of years" [ngValue]="y">{{ y - 1 }}</option>
		</select>
		<span *ngIf="selectedYear !== null" class="ml-3 text-muted small mb-0">
			Program Year {{ selectedYear - 1 }}&ndash;{{ selectedYear }}
		</span>
	</div>

	<div *ngIf="years.length === 0" class="text-muted">
		No committee assignments found for any year.
	</div>

	<ng-container *ngIf="selectedYear !== null">
		<ul class="nav nav-tabs mb-3">
			<li class="nav-item">
				<a class="nav-link" href="javascript:void(0)"
					[class.active]="activeTab === 'prc'"
					(click)="selectTab('prc')">Peer Review</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" href="javascript:void(0)"
					[class.active]="activeTab === 'adhoc'"
					(click)="selectTab('adhoc')">Ad Hoc</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" href="javascript:void(0)"
					[class.active]="activeTab === 'readonly'"
					(click)="selectTab('readonly')">Read-only Access</a>
			</li>
		</ul>

		<div *ngIf="loading" class="text-muted">Loading…</div>

		<!-- PRC: per-candidate reviewer sets; the highlighted reviewer writes the review -->
		<div *ngIf="!loading && activeTab === 'prc'">
			<div class="mb-2">
				<button class="btn btn-sm btn-primary" (click)="addPrcCandidate()">
					<i class="fa fa-plus"></i> Add candidate…
				</button>
			</div>
			<table class="table table-sm table-bordered committees-table" style="background: white;" *ngIf="prc.length > 0">
				<thead>
					<tr>
						<th style="width: 45%;">Candidate</th>
						<th>Reviewers</th>
						<th style="width: 110px;"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let c of prc; trackBy: trackByCandidate" [id]="'candidate-' + c.candidateUserId" [class.needs-reviewers]="c.caseId !== null && c.reviewers.length === 0">
						<td>
							{{ c.candidateName }}
							<div class="small">
								<a *ngIf="c.caseId !== null" [routerLink]="['/review/packet', c.caseId]">
									{{ c.caseDescription }} — {{ c.caseStatus }}
								</a>
								<span *ngIf="c.caseId === null" class="text-muted"
									title="No case with a peer review stage for this period">?</span>
							</div>
						</td>
						<td>
							<table class="table table-sm mb-1 inner-table" *ngIf="c.reviewers.length > 0">
								<tr *ngFor="let r of c.reviewers; trackBy: trackByUser"
									[title]="r.email + (r.writesReview ? ' — writes the review' : '')">
									<td>
										<strong *ngIf="r.writesReview">{{ r.name }}</strong>
										<ng-container *ngIf="!r.writesReview">{{ r.name }}</ng-container>
									</td>
									<td style="width: 44px;" class="text-right text-nowrap">
										<a href="javascript:void(0)" *ngIf="!r.writesReview"
											title="Make this reviewer the writer"
											(click)="makePrcWriter(c, r)"><i class="fa fa-pencil"></i></a>
										<a href="javascript:void(0)" class="ml-2 text-danger"
											title="Remove reviewer"
											(click)="removePrcReviewer(c, r)"><i class="fa fa-times"></i></a>
									</td>
								</tr>
							</table>
						</td>
						<td>
							<button class="btn btn-sm btn-primary" (click)="addPrcReviewer(c)">
								<i class="fa fa-plus"></i> Reviewer
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div *ngIf="prc.length === 0" class="text-muted">
				<em>No peer review committee assignments for this year.</em>
			</div>
			<p class="text-muted small" *ngIf="prc.length > 0">
				The bold reviewer writes the review. Red rows have a case that needs reviewers.
			</p>
		</div>

		<!-- Ad Hoc: one row per committee; the chair writes the review -->
		<div *ngIf="!loading && activeTab === 'adhoc'">

			<!-- Candidates whose case reaches an ad hoc stage with no committee to staff it -->
			<div *ngIf="adHocUnassigned.length > 0" class="mb-3">
				<h6>Needs an ad hoc committee — not yet assigned <span class="text-muted">({{ adHocUnassigned.length }})</span></h6>
				<table class="table table-sm table-bordered" style="background: white;">
					<thead>
						<tr>
							<th style="width: 30%;">Candidate</th>
							<th>Case</th>
							<th style="width: 260px;">Assign to</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let cand of adHocUnassigned; trackBy: trackByUser">
							<td>{{ cand.name }}</td>
							<td>
								<a [routerLink]="['/review/packet', cand.caseId]">
									{{ cand.caseDescription }} — {{ cand.caseStatus }}
								</a>
							</td>
							<td>
								<select #assignTo class="custom-select custom-select-sm"
									[disabled]="adHoc.length === 0"
									(change)="assignUnassignedCandidate(cand, assignTo)">
									<option value="">{{ adHoc.length === 0 ? 'No committees yet' : 'Choose a committee…' }}</option>
									<option *ngFor="let c of adHoc; trackBy: trackByCommittee" [value]="c.committeeId">
										{{ adHocCommitteeLabel(c) }}
									</option>
								</select>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="mb-2">
				<button class="btn btn-sm btn-primary" (click)="createAdHocCommittee()">
					<i class="fa fa-plus"></i> New committee
				</button>
			</div>
			<table class="table table-sm table-bordered committees-table" style="background: white;" *ngIf="adHoc.length > 0">
				<thead>
					<tr>
						<th style="width: 20%;">Committee</th>
						<th style="width: 32%;">Reviewers</th>
						<th>Candidates</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let c of adHoc; trackBy: trackByCommittee" [id]="'committee-' + c.committeeId" [class.needs-reviewers]="c.candidates.length > 0 && c.members.length === 0">
						<td>
							Committee {{ c.committeeId }}
							<!-- Only an empty committee can be deleted, which is rare enough that
							     the button rides along here rather than holding a column open. -->
							<a href="javascript:void(0)" class="ml-2 text-danger"
								*ngIf="c.members.length === 0 && c.candidates.length === 0"
								title="Delete this empty committee"
								(click)="deleteAdHocCommittee(c)"><i class="fa fa-trash"></i></a>
							<div class="small text-muted">
								<ng-container *ngIf="adHocChair(c) as chair">{{ chair.name }}</ng-container>
								<em *ngIf="!adHocChair(c)">no chair</em>
							</div>
						</td>
						<td>
							<table class="table table-sm mb-1 inner-table" *ngIf="c.members.length > 0">
								<tr *ngFor="let m of c.members; trackBy: trackByUser"
									[title]="m.email + (m.writesReview ? ' — chair; writes the review' : '')">
									<td>
										<strong *ngIf="m.writesReview">{{ m.name }}</strong>
										<ng-container *ngIf="!m.writesReview">{{ m.name }}</ng-container>
									</td>
									<td style="width: 44px;" class="text-right text-nowrap">
										<a href="javascript:void(0)" *ngIf="!m.writesReview"
											title="Make chair"
											(click)="makeAdHocChair(c, m)"><i class="fa fa-pencil"></i></a>
										<a href="javascript:void(0)" class="ml-2 text-danger"
											title="Remove member"
											(click)="removeAdHocMember(c, m)"><i class="fa fa-times"></i></a>
									</td>
								</tr>
							</table>
							<div class="text-right">
								<button class="btn btn-sm btn-primary mt-1" (click)="addAdHocMember(c)">
									<i class="fa fa-plus"></i> Member
								</button>
							</div>
						</td>
						<td>
							<table class="table table-sm mb-1 inner-table" *ngIf="c.candidates.length > 0">
								<tr *ngFor="let cand of c.candidates; trackBy: trackByUser">
									<td style="width: 45%;">{{ cand.name }}</td>
									<td>
										<a *ngIf="cand.caseId !== null" [routerLink]="['/review/packet', cand.caseId]">
											{{ cand.caseDescription }} — {{ cand.caseStatus }}
										</a>
										<span *ngIf="cand.caseId === null" class="text-muted"
											title="No case with an ad hoc stage for this period">?</span>
									</td>
									<td style="width: 24px;" class="text-right">
										<a href="javascript:void(0)" class="text-danger"
											title="Unassign candidate"
											(click)="unassignAdHocCandidate(c, cand)"><i class="fa fa-times"></i></a>
									</td>
								</tr>
							</table>
							<div class="text-right">
								<button class="btn btn-sm btn-primary mt-1" (click)="assignAdHocCandidate(c)">
									<i class="fa fa-plus"></i> Assign candidate…
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div *ngIf="adHoc.length === 0" class="text-muted">
				<em>No ad hoc committees for this year.</em>
			</div>
			<p class="text-muted small" *ngIf="adHoc.length > 0">
				The bold member chairs the committee and writes the review. Red rows have candidates but no members.
			</p>
		</div>

		<!-- Read-only access: candidate groups + the reviewers granted view access -->
		<div *ngIf="!loading && activeTab === 'readonly'">
			<p class="text-muted small">
				Read-only reviewers can view (but not act on) the candidates in their group.
			</p>
			<div *ngIf="readOnlyGroups.length === 0" class="mb-3">
				<div class="text-muted mb-2">
					<em>No read-only access set up for this year. Adding the first reviewer creates the
					candidate group.</em>
				</div>
				<button class="btn btn-sm btn-primary mr-2" (click)="addReadOnlyReviewer('prc')">
					<i class="fa fa-plus"></i> PRC read-only reviewer…
				</button>
				<button class="btn btn-sm btn-primary" (click)="addReadOnlyReviewer('adhoc')">
					<i class="fa fa-plus"></i> Ad Hoc read-only reviewer…
				</button>
			</div>
			<div class="card mb-3" *ngFor="let g of readOnlyGroups; trackBy: trackByGroup">
				<div class="card-header">Candidate group {{ g.groupId }}</div>
				<div class="card-body">
					<div class="row">
						<div class="col-md-4">
							<div class="text-muted small mb-1">PRC read-only reviewers</div>
							<div class="d-flex justify-content-between" *ngFor="let m of g.prcUsers; trackBy: trackByUser" [title]="m.email">
								<span>{{ m.name }}</span>
								<a href="javascript:void(0)" class="text-danger" title="Remove"
									(click)="removeReadOnlyReviewer('prc', m)"><i class="fa fa-times"></i></a>
							</div>
							<div class="text-muted" *ngIf="g.prcUsers.length === 0"><em>None</em></div>
							<button class="btn btn-sm btn-primary mt-2" (click)="addReadOnlyReviewer('prc', g)">
								<i class="fa fa-plus"></i> Reviewer
							</button>
						</div>
						<div class="col-md-4">
							<div class="text-muted small mb-1">Ad Hoc read-only reviewers</div>
							<div class="d-flex justify-content-between" *ngFor="let m of g.adHocUsers; trackBy: trackByUser" [title]="m.email">
								<span>{{ m.name }}</span>
								<a href="javascript:void(0)" class="text-danger" title="Remove"
									(click)="removeReadOnlyReviewer('adhoc', m)"><i class="fa fa-times"></i></a>
							</div>
							<div class="text-muted" *ngIf="g.adHocUsers.length === 0"><em>None</em></div>
							<button class="btn btn-sm btn-primary mt-2" (click)="addReadOnlyReviewer('adhoc', g)">
								<i class="fa fa-plus"></i> Reviewer
							</button>
						</div>
						<div class="col-md-4">
							<div class="text-muted small mb-1">Candidates ({{ g.candidates.length }})</div>
							<div style="max-height: 300px; overflow-y: auto;">
								<div class="d-flex justify-content-between" *ngFor="let cand of g.candidates; trackBy: trackByUser">
									<span>{{ cand.name }}</span>
									<a href="javascript:void(0)" class="text-danger" title="Remove"
										(click)="removeReadOnlyCandidate(g, cand)"><i class="fa fa-times"></i></a>
								</div>
							</div>
							<div class="text-muted" *ngIf="g.candidates.length === 0"><em>None</em></div>
							<button class="btn btn-sm btn-primary mt-2" (click)="addReadOnlyCandidate(g)">
								<i class="fa fa-plus"></i> Candidate
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>
